import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Паримутюэль коэффициент (uuid сравнения — строки)
export function calcCoef(bets, matchId, teamId) {
  const mb = bets.filter(b => b.match_id === matchId && b.type !== 'champion');
  const total = mb.reduce((s, b) => s + Number(b.amount), 0);
  const teamPool = mb.filter(b => b.team_id === teamId).reduce((s, b) => s + Number(b.amount), 0);
  if (total === 0 || teamPool === 0) return 2.0;
  return Math.max(1.01, (total * 0.95) / teamPool);
}

export const api = {
  async getTournaments() {
    const { data } = await supabase
      .from('tournaments')
      .select('*')
      .order('created_at', { ascending: false });
    return data || [];
  },

  async getFullTournamentData(tId) {
    const [matchesRes, teamsRes, betsRes] = await Promise.all([
      supabase
        .from('matches')
        .select('*, teamA:team_a_id(id,name), teamB:team_b_id(id,name)')
        .eq('tournament_id', tId),
      supabase
        .from('teams')
        .select('*')
        .eq('tournament_id', tId),
      supabase
        .from('bets')
        .select('*')
        .eq('tournament_id', tId),
    ]);

    // Нормализуем матчи: team_a_id/team_b_id могут прийти как объект из join
    const matches = (matchesRes.data || []).map(m => ({
      ...m,
      team_a_id: m.teamA?.id ?? m.team_a_id,
      team_b_id: m.teamB?.id ?? m.team_b_id,
    }));

    return {
      matches,
      teams: teamsRes.data || [],
      bets: betsRes.data || [],
    };
  },

  async placeBet({ tournament_id, match_id, team_id, nick, amount, type = 'match' }) {
    const { data, error } = await supabase
      .from('bets')
      .insert([{ tournament_id, match_id, team_id, nick, amount: Number(amount), type }]);
    return { data, error };
  },

  async updateMatchResult(matchId, { winner_id, score, status = 'done' }) {
    const { data, error } = await supabase
      .from('matches')
      .update({ winner_id, score, status })
      .eq('id', matchId);
    return { data, error };
  },

  async setChampion(tournamentId, champion) {
    const { data, error } = await supabase
      .from('tournaments')
      .update({ champion })
      .eq('id', tournamentId);
    return { data, error };
  },
};
